import { render, staticRenderFns } from "./ProgramCategoryForm.vue?vue&type=template&id=390a010a"
import script from "./ProgramCategoryForm.vue?vue&type=script&lang=js"
export * from "./ProgramCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports